<template>
  <wrld-container :breadcrumbs="this.breadcrumbs">
    <wrld-box :headerTitle="$t('routes.route_new')">
      <template v-slot:boxContent>
        <v-container>
          <v-col cols="12">
            <v-text-field
              v-model="route.name"

              color="kazan"
              :label="$t('routes.name')"
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="route.vehicles"
              :items="vehiclesList"

              chips
              color="kazan"
              :label="$t('routes.vehicles')"
              item-text="name"
              item-value="name"
              multiple
            >
              <template v-slot:selection="data">
                <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="removeVehicle(data.item)"
                >
                  {{ data.item }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <template>
                  <v-list-item-content v-text="data.item"/>
                </template>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="route.locations"
              :items="locationsList"

              chips
              color="kazan"
              :label="$t('routes.locations')"
              item-text="name"
              item-value="name"
              multiple
            >
              <template v-slot:selection="data">
                <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="removeLocation(data.item)"
                >
                  {{ data.item }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <template>
                  <v-list-item-content v-text="data.item"/>
                </template>
              </template>
            </v-autocomplete>
          </v-col>
        </v-container>
      </template>
    </wrld-box>
    <v-btn @click="callGoBack()">{{$t('buttons.cancel')}}</v-btn>
    <v-btn @click="callUpdateRoute()">{{$t('buttons.save')}}</v-btn>
  </wrld-container>
</template>

<script>
import router from '@/router'

export default {
  name: 'OrderUpdate',
  data () {
    return {
      breadcrumbs: [
        { text: 'Wereldo', disabled: false, href: '#/' },
        { text: this.$i18n.tc('routes.routes', 2), disabled: false, href: '#/routes' },
        { text: this.$i18n.t('routes.form'), disabled: true }
      ],
      route: {
        name: '',
        vehicles: [],
        locations: []
      }
    }
  },
  computed: {
    vehiclesList () {
      return ['Vehicle A', 'Vehicle B', 'Vehicle C']
    },
    locationsList () {
      return ['Location A', 'Location B', 'Location C', 'Group A', 'Group B']
    }
  },
  methods: {
    callUpdateRoute () {
      console.log(this.route)
    },
    callGoBack () {
      router.push({ name: 'Routes' })
    },
    removeVehicle (item) {
      const index = this.route.vehicles.indexOf(item)
      if (index >= 0) this.route.vehicles.splice(index, 1)
    },
    removeLocation (item) {
      const index = this.route.locations.indexOf(item)
      if (index >= 0) this.route.locations.splice(index, 1)
    }
  }
}
</script>
